export const globalSettingKeys = {
  all: ["globalsettings"] as const,
  setting: (name: string) => [...globalSettingKeys.all, name] as const,
};
